/* tslint:disable:max-classes-per-file */
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpParameterCodec,
    HttpParams,
    HttpRequest
} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

class CustomEncoder implements HttpParameterCodec {
    public encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    public encodeValue(value: string): string {
        return encodeURIComponent(value);
    }

    public decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    public decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}

@Injectable()
export class CustomApiInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const params = new HttpParams({encoder: new CustomEncoder(), fromString: req.params.toString()});
        return next.handle(req.clone({params}));
    }
}
